// removed by extract-text-webpack-plugin
module.exports = {"dot":"style__dot___2wm12","wrapper":"style__wrapper___1XrjN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel-indicators/style.css
// module id = 530
// module chunks = 0